import { ModelHelper } from '@ibiz-template/model-helper';
import { AppHooks } from '@ibiz-template/vue3-util';
import { AuthGuard } from './auth-guard';

export class DynaAuthGuard extends AuthGuard {
  hasModelInit: boolean = false;

  noPermissionModel: boolean = false;

  async initModel(context: IParams, permission: boolean = true): Promise<void> {
    // 没初始化或者初始化了但是切换模型
    if (
      !this.hasModelInit ||
      (this.hasModelInit && this.noPermissionModel !== permission)
    ) {
      // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
      const helper = new ModelHelper(
        async url => {
          if (ibiz.env.isLocalModel) {
            const res = await ibiz.net.getModel(`./model${url}`);
            return res.data;
          }
          const res = await ibiz.net.get(
            `${ibiz.env.remoteModelUrl}${url}`,
            undefined,
            permission ? {} : { srfdcsystem: ibiz.env.dcSystem },
          );
          return res.data;
        },
        ibiz.env.appId,
        context,
        permission,
      );
      const app = await ibiz.hub.getAppAsync(ibiz.env.appId);
      await this.initEnvironment(app.model);
      await AppHooks.initedApp.call({ context, app });
      const appModel = app.model;
      ibiz.env.isMob = appModel.mobileApp === true;
      await this.initTheme(app.model);
      // 设置浏览器标题
      if (app.model.title) {
        ibiz.util.setBrowserTitle('');
      }
    }

    this.noPermissionModel = permission;
    this.hasModelInit = true;
  }
}
